"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var modal_dialog_service_1 = require("@nw/ui-core-shared/services/modal-dialog.service");
var core_2 = require("@ngx-translate/core");
var DealerblockBestOfferCounteredCommentsV1Component = (function () {
    function DealerblockBestOfferCounteredCommentsV1Component(modalDialogService, translateService) {
        this.modalDialogService = modalDialogService;
        this.translateService = translateService;
    }
    DealerblockBestOfferCounteredCommentsV1Component.prototype.ngOnInit = function () {
    };
    return DealerblockBestOfferCounteredCommentsV1Component;
}());
DealerblockBestOfferCounteredCommentsV1Component.decorators = [
    { type: core_1.Component, args: [{
                selector: 'nw-dealerblock-best-offer-countered-comments-v1',
                template: "<div *ngIf=\"boCounteredComments\" class=\"row align-items-start wrap-content\" data-a8n=\"db-best-offer-countered-comments\">\n    <div class=\"col-3 db-seller-notes-title\">\n        {{'dealerBlockLayout.sellerNotes' | translate }}\n    </div>\n    <div class=\"col-9 db-seller-notes-content\">\n        <span>{{boCounteredComments}}</span>\n    </div>\n</div>",
                styles: [".db-seller-notes-title{   font-size: 12px;   font-family: Heebo;   color: #7A7A7A; } .db-seller-notes-content{   font-size: 12px;   color: #474B51;   font-family: Heebo;   font-weight: 500;   line-height: 16px;   word-break: break-all;   width: 100%; }"]
            },] },
];
/** @nocollapse */
DealerblockBestOfferCounteredCommentsV1Component.ctorParameters = function () { return [
    { type: modal_dialog_service_1.ModalDialogService, },
    { type: core_2.TranslateService, },
]; };
DealerblockBestOfferCounteredCommentsV1Component.propDecorators = {
    'boCounteredComments': [{ type: core_1.Input },],
    'allowBestOffer': [{ type: core_1.Input },],
};
exports.DealerblockBestOfferCounteredCommentsV1Component = DealerblockBestOfferCounteredCommentsV1Component;
//# sourceMappingURL=dealerblock-best-offer-countered-comments-v1.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nw/dealerblock-bid-ui/components/components-v1/dealerblock-best-offer-countered-comments-v1/dealerblock-best-offer-countered-comments-v1.js
// module id = fKFs
// module chunks = 0